import { render, staticRenderFns } from "./ToddlerMortalityReport.vue?vue&type=template&id=aa5a1aae&scoped=true"
import script from "./ToddlerMortalityReport.vue?vue&type=script&lang=js"
export * from "./ToddlerMortalityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5a1aae",
  null
  
)

export default component.exports